import React, { useRef } from "react";
import { useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex/AdminFormPage";
import ExpenseForm from "../ExpenseForm/ExpenseForm";

const FORM_ID = "expense-form";

function New({ project_id, account, permission, project }) {
  const navigate = useNavigate();
  const saveAndAddAnotherRef = useRef(false);

  const canSave =
    permission !== "view" && project?.data?.attributes?.status === "building";

  const triggerSaveAndAddAnother = () => {
    saveAndAddAnotherRef.current = true;
    (
      document.getElementById(FORM_ID) as HTMLFormElement | null
    )?.requestSubmit();
  };

  return (
    <AdminFormPage
      title="Add Travel and Expense"
      formId={canSave ? FORM_ID : undefined}
      onCancel={() =>
        navigate(`/projects/${project_id}/project_expenses`, {
          state: null,
        })
      }
      onSaveAndAddAnother={canSave ? triggerSaveAndAddAnother : undefined}
    >
      <ExpenseForm
        formId={FORM_ID}
        saveAndAddAnotherRef={saveAndAddAnotherRef}
        project_id={project_id}
        account={account}
        permission={permission}
        project={project}
      />
    </AdminFormPage>
  );
}

export default New;
